export class CompletionRateStats {
  nbSuccess: number = 0;
  nbFailed: number = 0;
  nbInProgress: number = 0;
  nbUnread: number = 0;

  constructor(stats?: Partial<CompletionRateStats>) {
    Object.assign(this, stats);
  }
}
